import React from 'react';
import PropTypes from 'prop-types';

import GroupedDropdown from '../../../../components/GroupedDropdown';
import messages from './messages';

import '../styles.css';

export const buildGroupedOptions = (options) => options.reduce((acc, { value, raw }) => {
  acc.push({
    header: value,
    values: raw,
  });

  Object.keys(raw).forEach((key) => {
    acc.push({
      text: raw[key],
      value: key,
      key,
    });
  });

  return acc;
}, []);

export const getSelectionsFromValue = (value) => {
  const selections = value ? JSON.parse(value) : [];
  return selections.map(({ name }) => name);
};

export const getValueFromSelectedSystems = (selectedSystems = [], options) => {
  const systems = selectedSystems.map((system) => {
    const found = options.find(({ raw }) => system in raw);
    /* istanbul ignore else */
    if (found) {
      return {
        name: system,
        description: found.raw[system],
      };
    }
    return null;
  });
  return JSON.stringify(systems);
};

const CollegeSystems = ({ onChange, initialValue, formatMessage }) => {
  const groupedOptions = buildGroupedOptions(initialValue.options);
  const dropdownValue = getSelectionsFromValue(initialValue.value);

  const handleChange = (e, { value }) => {
    const newValue = getValueFromSelectedSystems(value, initialValue.options);
    onChange(e, { value: newValue });
  };

  return (
    <div
      styleName="college-systems-container"
      data-cy="Premium-Hem-Transfer-College-Systems-Container"
    >
      <p styleName="transfer-info-intro">{formatMessage(messages.collegeSystemsIntro)}</p>
      <GroupedDropdown
        placeholder={formatMessage(messages.collegeSystemsPlaceholder)}
        fluid
        selection
        lazyLoad
        multiple
        search
        options={groupedOptions}
        onChange={handleChange}
        value={dropdownValue}
        styleName="college-systems-dropdown"
        noResultsMessage={formatMessage(messages.collegeSystemsNoResults)}
      />
    </div>
  );
};

CollegeSystems.propTypes = {
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  initialValue: PropTypes.object,
};
export default CollegeSystems;
